import angular from 'angular';

import WidgetsLibraryComponent from './widgets-library.component';

export default angular.module('dbm.dashboard.components.widgets-library', [])
.component('dbmWidgetsLibrary', WidgetsLibraryComponent)
.name;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/widgets-library/index.js